import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_ELECTRICITY_SUPPLIER,
  FETCH_ELECTRICITY_SUPPLIER_FAIL,
  FETCH_ELECTRICITY_SUPPLIER_SUCCESS,
  GET_ELECTRICITY_SUPPLIER,
  GET_ELECTRICITY_SUPPLIER_SUCCESS,
  GET_ELECTRICITY_SUPPLIER_FAIL,
  CREATE_ELECTRICITY_SUPPLIER,
  CREATE_ELECTRICITY_SUPPLIER_SUCCESS,
  CREATE_ELECTRICITY_SUPPLIER_FAIL,
  UPDATE_ELECTRICITY_SUPPLIER,
  UPDATE_ELECTRICITY_SUPPLIER_SUCCESS,
  UPDATE_ELECTRICITY_SUPPLIER_FAIL,
  DELETE_ELECTRICITY_SUPPLIER,
  DELETE_ELECTRICITY_SUPPLIER_SUCCESS,
  DELETE_ELECTRICITY_SUPPLIER_FAIL,
} from 'actions/electricitySupplier';

function* fetchElectricitySupplier(action) {
  try {
    const response = yield call(API.getElectricitySuppliers, action.payload);
    yield put({ type: FETCH_ELECTRICITY_SUPPLIER_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_ELECTRICITY_SUPPLIER_FAIL, payload: { error: e } });
  }
}

function* getElectricitySupplierById(action) {
  try {
    const response = yield call(API.getElectricitySuppliersById, action.payload);
    yield put({ type: GET_ELECTRICITY_SUPPLIER_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_ELECTRICITY_SUPPLIER_FAIL, payload: { error: e } });
  }
}

function* createElectricitySupplier(action) {
  try {
    const response = yield call(API.addElectricitySuppliers, action.payload);
    yield put({ type: CREATE_ELECTRICITY_SUPPLIER_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_ELECTRICITY_SUPPLIER_FAIL, payload: { error: e } });
  }
}

function* updateElectricitySupplier(action) {
  try {
    const response = yield call(API.updateElectricitySuppliers, action.payload);
    yield put({ type: UPDATE_ELECTRICITY_SUPPLIER_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_ELECTRICITY_SUPPLIER_FAIL, payload: { error: e } });
  }
}

function* deleteElectricitySupplier(action) {
  try {
    const response = yield call(API.deleteElectricitySuppliers, action.payload);
    yield put({ type: DELETE_ELECTRICITY_SUPPLIER_SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_ELECTRICITY_SUPPLIER_FAIL, payload: { error: e } });
  }
}

function* electricitySupplier() {
  yield takeLatest(FETCH_ELECTRICITY_SUPPLIER, fetchElectricitySupplier);
  yield takeLatest(GET_ELECTRICITY_SUPPLIER, getElectricitySupplierById);
  yield takeLatest(CREATE_ELECTRICITY_SUPPLIER, createElectricitySupplier);
  yield takeLatest(UPDATE_ELECTRICITY_SUPPLIER, updateElectricitySupplier);
  yield takeLatest(DELETE_ELECTRICITY_SUPPLIER, deleteElectricitySupplier);
}

export default electricitySupplier;
